<template>
  <v-container class="mb-4" fluid>
    <transition name="scroll-y-transition">
      <v-row v-if="hasTabelaPrecoItem">
        <v-col cols="12">
          <v-alert
            type="success"
            outlined
            v-once
            class="rounded-tag-small body-2"
            dismissible>
            Carregamos os preços dos produtos de acordo com suas tabelas de preço.
          </v-alert>
        </v-col>
      </v-row>
    </transition>
    <template v-for="(produto, index) in compra.produtos">
      <px-cadastro-compra-produtos-table-item :compra="compra"
                                              :produto="produto"
                                              :is-a-vista="isAVista"
                                              :hide-acoes="hideAcoes"
                                              :is-editing="isEditing"
                                              :is-rascunho="isRascunho"
                                              :campos-hidden="camposHidden"
                                              :campos-readonly="camposReadonly"
                                              :is-from-requisicao="isFromRequisicao"
                                              :campos-obrigatorios="camposObrigatorios"
                                              :erp-campos-integracao="erpCamposIntegracao"
                                              :key="produto.$$id"
                                              ref="produtos"
                                              @remove="onRemoveProduto(index)"
                                              @replicar-campo="onReplicarCampo"/>
    </template>
    <v-row dense class="mt-3" v-if="!hideAcoes">
      <v-col cols="12" class="text-right">
        <v-btn small
               color="primary"
               class="normal-btn-text elevation-0 rounded-tag-small"
               @click="onAddNewProduto">
          <v-icon small>mdi-plus</v-icon>
          Produto
        </v-btn>
      </v-col>
    </v-row>
    <v-row dense class="mt-2 mb-2" v-if="loadingTaxa">
      <v-col cols="12" align="center">
        <px-circular-loading/>
      </v-col>
    </v-row>
    <v-row dense class="mt-2 mb-2" v-if="!loadingTaxa">
      <v-col cols="12" v-if="isMoedaEstrangeira">
        <px-moeda-chip :moeda="moeda"/>
      </v-col>
      <v-col cols="12" sm="4" v-if="isMoedaEstrangeira">
        <template>
          <v-row dense no-gutters class="body-1">
            <v-col cols="6">
              Produtos:
            </v-col>
            <v-col cols="6" class="text-right">
              {{ totaisCompra.totalProdutos |
                    currency(simboloMoeda, casaDecimal, configuracaoFormatacaoMoeda) }}
            </v-col>
            <v-col cols="6">
              Frete:
            </v-col>
            <v-col cols="6" class="text-right">
              {{ totaisTransporte.totalTransporte |
                    currency(simboloMoeda, 2, configuracaoFormatacaoMoeda)}}
            </v-col>
            <v-col cols="6" class="font-weight-bold">
              Total:
            </v-col>
            <v-col cols="6" class="text--primary--color font-weight-bold text-right">
              {{ totaisCompra.total |
                    currency(simboloMoeda, casaDecimal, configuracaoFormatacaoMoeda) }}
            </v-col>
            <template v-if="totaisSaving.saving > 0">
              <v-col cols="6" class="font-weight-bold">
                Saving:
              </v-col>
              <v-col cols="6" class="text--success--color font-weight-bold text-right">
                {{
                  totaisSaving.saving |
                    currency(simboloMoeda, 2, configuracaoFormatacaoMoeda)
                }}
              </v-col>
            </template>
          </v-row>
        </template>
      </v-col>
      <v-col cols="12" sm="4" v-if="isMoedaEstrangeira">
      </v-col>
      <v-col cols="12" sm="4">
        <v-row dense no-gutters class="body-1">
          <v-col cols="6">
            Produtos:
          </v-col>
          <v-col cols="6" class="text-right">
            {{ totaisCompra.totalProdutosConvertido | currency('R$', casaDecimal) }}
          </v-col>
          <v-col cols="6">
            Frete:
          </v-col>
          <v-col cols="6" class="text-right">
            {{ totaisTransporte.totalTransporteConvertido | currency('R$', 2) }}
          </v-col>
          <v-col cols="6" class="font-weight-bold">
            Total:
          </v-col>
          <v-col cols="6" class="text--primary--color font-weight-bold text-right">
            {{ totaisCompra.totalConvertido | currency('R$', casaDecimal) }}
          </v-col>
          <template v-if="totaisSaving.savingConvertido > 0">
            <v-col cols="6" class="font-weight-bold">
              Saving:
            </v-col>
            <v-col cols="6" class="text--success--color font-weight-bold text-right">
              {{ totaisSaving.savingConvertido | currency('R$', 2) }}
            </v-col>
          </template>
        </v-row>
      </v-col>
    </v-row>
    <div class="mt-5">
      <v-btn color="primary"
             class="rounded-tag-small elevation-0 normal-btn-text"
             @click="salvar"
             :loading="loading"
             :disabled="!compra.produtos.length">
        Salvar
      </v-btn>
      <v-btn @click="saveDraft"
             v-if="!isEditing"
             class="rounded-tag-small elevation-0 normal-btn-text ml-2">
        Salvar rascunho
      </v-btn>
      <v-btn text class="normal-btn-text" @click="previous">Voltar</v-btn>
    </div>
  </v-container>
</template>

<script>
import validationMixin from '@/mixins/validation-mixin';
import {
  calcularTotaisCompra,
  calcularTotaisSaving,
  calcularTotaisTransporte,
} from '@/modules/compra/cadastro/calculo-compra.service';
import CadastroCompraProdutosTableItem
  from '@/modules/compra/cadastro/CadastroCompraProdutosTableItem.vue';
import { initialStateProduto, mapValoresTabelaPreco } from '@/modules/compra/cadastro/compra-utils';
import TabelaPrecoService from '@/modules/tabela-preco/tabela-preco-service';
import { formatToCode } from '@/utils/moment-date-utils';
import moment from 'moment';
import { FormaPagamento } from 'px-business-components';
import moedaMixin from '@/mixins/moeda-mixin';
import { CasaDecimalUtils } from 'px-components';
import { replicarCampoProdutos } from '@/utils/cadastros-adicionais-utils';
import MoedaService from '@/api/valor-moeda-service';
import { isEmpty } from 'lodash';

export default {
  mixins: [validationMixin, moedaMixin],
  props: {
    compra: {
      type: Object,
      required: true,
    },
    erpCamposIntegracao: {
      type: String,
      default: null,
    },
    camposObrigatorios: {
      type: Object,
      default: null,
    },
    camposReadonly: {
      type: Object,
      default: null,
    },
    camposHidden: {
      type: Object,
      default: null,
    },
    isFromRequisicao: {
      type: Boolean,
      default: false,
    },
    usaTabelaPreco: {
      type: Boolean,
      default: false,
    },
    hideAcoes: {
      type: Boolean,
      default: false,
    },
    loading: Boolean,
    isEditing: Boolean,
    isRascunho: Boolean,
  },
  data() {
    return {
      loadingTaxa: false,
      taxaVenda: null,
      itensTabelaPreco: [],
    };
  },
  computed: {
    moeda() {
      return this.compra.moeda;
    },
    totaisCompra() {
      return calcularTotaisCompra(this.compra, this.compra.produtos, this.taxaVenda);
    },
    totaisSaving() {
      return calcularTotaisSaving(this.compra, this.taxaVenda);
    },
    totaisTransporte() {
      return calcularTotaisTransporte(this.compra, this.taxaVenda);
    },
    isAVista() {
      return this.compra.formaPagamento === FormaPagamento.keys.A_VISTA.key;
    },
    hasTabelaPrecoItem() {
      return this.compra.produtos.find(p => p.$$itemTabelaPreco);
    },
    casaDecimal() {
      const mappedProdutos = this.compra.produtos
        .map(produto => produto.produto)
        .filter(produto => produto);
      return CasaDecimalUtils.getCasaDecimal(mappedProdutos);
    },
  },
  methods: {
    validate() {
      return this.$refs.produtos.map(produto => produto.validate())
        .every(validation => validation);
    },
    getTaxaVendaMoeda(moeda) {
      this.loadingTaxa = true;

      MoedaService.getTaxaVendaMoeda(moeda)
        .then(({ data }) => {
          this.taxaVenda = data.taxaVenda;
        }).finally(() => {
          this.loadingTaxa = false;
        });
    },
    onAddNewProduto() {
      this.compra.produtos.push({
        ...initialStateProduto(this.erpCamposIntegracao, this.compra),
      });
    },
    onRemoveProduto(index) {
      this.compra.produtos.splice(index, 1);
    },
    onReplicarCampo(campo) {
      if (!campo) {
        return;
      }
      this.compra.produtos = replicarCampoProdutos(this.compra.produtos, campo);
    },
    salvar() {
      if (!this.validate()) {
        return;
      }
      this.$emit('ready');
    },
    previous() {
      this.$emit('previous');
    },
    saveDraft() {
      if (!this.validate()) {
        return;
      }
      this.$emit('save-draft');
    },
    /**
     * Faz o update dos valores que dependem do prazo e forma de pagamento
     */
    updateValoresTabelaPreco() {
      this.compra.produtos = this.compra.produtos.map((produto) => {
        if (!produto.produto || !produto.$$itemTabelaPreco) {
          return produto;
        }
        return mapValoresTabelaPreco(produto, produto.$$itemTabelaPreco, this.isAVista);
      });
    },
    setValoresTabelaPreco() {
      if (!this.itensTabelaPreco || !this.itensTabelaPreco.length
          || !this.compra.produtos.length) {
        return;
      }
      this.compra.produtos = this.compra.produtos.map((produto) => {
        if (!produto.produto) {
          return produto;
        }
        const itemTabelaPreco = this.itensTabelaPreco
          .find(item => item.produto.id === produto.produto.id);
        if (!itemTabelaPreco) {
          return produto;
        }
        return mapValoresTabelaPreco(produto, itemTabelaPreco, this.isAVista);
      });
    },
    getTabelaPreco() {
      const idProdutosValidos = this.compra.produtos
        .filter(p => p.produto)
        .map(p => p.produto.id);

      if (isEmpty(idProdutosValidos)) {
        return;
      }
      const produtosFilters = idProdutosValidos.map(id => `produto.id = ${id}`);

      const dataAtual = formatToCode(moment());
      const query = `fornecedor.id = ${this.compra.fornecedor.id} and ativo = true and (${produtosFilters.join(' or ')}) and dataVigenciaInicial <= ${dataAtual} and dataVigenciaFinal >= ${dataAtual}`;

      TabelaPrecoService.getItensTabelaPreco({
        query,
      })
        .then(({ data }) => {
          if (!data || !data.length) {
            return;
          }
          this.itensTabelaPreco = data;
          this.setValoresTabelaPreco(data);
        });
    },
    computaTabelaPrecoFornecedor() {
      if (!this.usaTabelaPreco || this.editing || this.isRascunho) {
        return;
      }
      this.getTabelaPreco();
    },
  },
  created() {
    if (!this.taxaVenda && this.moeda) {
      this.getTaxaVendaMoeda(this.moeda);
    }
  },
  watch: {
    'compra.fornecedor': function (newValue, oldValue) {
      if (newValue === oldValue || !newValue) {
        return;
      }
      this.computaTabelaPrecoFornecedor();
    },
    'compra.formaPagamento': function (newValue, oldValue) {
      if (newValue === oldValue || !newValue) {
        return;
      }
      this.updateValoresTabelaPreco();
    },
    'compra.moeda': function (newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.getTaxaVendaMoeda(newValue);
    },
  },
  components: {
    pxCadastroCompraProdutosTableItem: CadastroCompraProdutosTableItem,
  },
};
</script>
